import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { PeriodSubForm, Schema as PeriodSchema } from '../subforms/Period';
import { OtherInformationInformalSubForm } from '../subforms/OtherInformationInformal';
import { DocumentsInformalSubForm, Schema as DocumentsInformalSchema } from '../subforms/DocumentsInformal';

export const WeserEnergiePraktikantSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(PeriodSchema)
        .concat(DocumentsInformalSchema(settings))
);

export const WeserEnergiePraktikant = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={PeriodSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationInformalSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsInformalSubForm} colors={colors} settings={settings} />
        </>
    );
}